var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"import-in-progress"},[_c('CustomerImportInProgress',{attrs:{"modal":true},on:{"failed":_vm.handleFailed,"completed":_vm.handleCompleted,"keep-exploring":_vm.handleKeepExploring}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }